import { ChangeEvent, useEffect, useRef, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import { OrderByDirection, WhereFilterOp } from "firebase/firestore";
import styled from "styled-components";
import * as XLSX from 'xlsx';
import useFirebaseAuth from "shared/hooks/useFirebaseAuth";
import useGetBranchId from "shared/hooks/useGetBranchId";
import { hw } from "features/homework/homeworkUi";

interface sort{
    name:string,
    direction:OrderByDirection,
}

interface AccountRow {
    branch_id:string,
    id:string,
    pw:string,
    name:string,
    parent_name:string,
    parent_tel:string,
    join_date:string,
    school:string,
    level:string,
    register_date:Date,
    fee:0,
    shuttle:boolean,
    tel:string,
    unpaied:0
}
interface ExcelRow {
    NO: string;
    성명: string;
    아이디: string;
    비밀번호: string;
    부모성함: string;
    부모연락처: string;
    학교학년: string;
    입원연월일: number;
    수강반명: string;
}

const useListView = (table:string, searchedItem:string, clickedItem:string, setClickedItem:React.Dispatch<React.SetStateAction<string>>, searchField:string) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<number>(0);
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const {getBranchId} = useGetBranchId();
    const [modal, setModal] = useState({
        title:"",
        content:"",
        onClick:() => {}
    });
    const uid = sessionStorage.getItem("uid") || "";
    const { readFirestoreWithQuery, readFirestoreOneDoc, writeFirestore } = useFirestore();
    const {createAccount} = useFirebaseAuth();
    const [search, setSearch] = useState<string>('');
    const [lists, setLists] = useState<any[]>([]);
    const [searchedLists, setSearchedLists] = useState<any[]>([]);
    const [file, setFile] = useState<File>();
    const fileRef = useRef<HTMLInputElement>(null);
    useEffect(() => {
        getList();
        // eslint-disable-next-line
    }, [table])

    const onChange = (e:ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    }

    const onRefreshClick = () => {
       getList();
    }

    const getList = async() => {
        interface data{
            id:string,
            name:string,
        }
        setLists([]);
        setSearchedLists([]);
        const branch_id = await getBranchId();
        const data_list = await readFirestoreWithQuery(table, {field:"branch_id", operator:"==", data:branch_id}).then(res => {
            const list = [];
            const doc_list = res.docs;
            for(const doc of doc_list){
                list.push({id:doc.id, name:doc.data().name});
            }
            return list;
        })

        data_list.sort(function(a:data, b:data):number{
            if(a.name < b.name){
                return -1;
            }else{
                return 1;
            }
        })
        setLists(data_list);
        setSearchedLists(data_list);
    }

    useEffect(() => {
        const searchedItems = lists.filter((item) => item[searchField].includes(search));
        setSearchedLists(searchedItems);
        // eslint-disable-next-line
    }, [search])

    const showList = () => {
        if (!searchedLists.length) {
            return <Empty>검색된 {search ? "결과가" : "계정이"} 없습니다.</Empty>
        }
        return searchedLists.map((item, index) => {
            const itemId = item.uid || item.id;
            return (
                <Item
                    key={itemId || index + 1}
                    $active={itemId === clickedItem}
                    onClick={() => setClickedItem(itemId)}
                >
                    {item[searchField]}
                </Item>
            )
        })
    }

    function generateRandomNumber() {
        return Math.floor(1000 + Math.random() * 9000);
    }

    function excelDateToString(serial: number): string {
        const excelEpoch = new Date(1899, 11, 30); // Excel 날짜 기준: 1899-12-30
        const date = new Date(excelEpoch.getTime() + (serial - 1) * 86400000); // serial 날짜를 일수로 변환
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
      
    
    const handleReadExcel = (file: File | null) => {
        if (file) {
            const reader = new FileReader();
            reader.onload = async (e: ProgressEvent<FileReader>) => {
                if (!e.target) {
                    return null;
                }
    
                const binaryStr = e.target.result as string;
                const workbook = XLSX.read(binaryStr, { type: 'binary' });
    
                // 첫 번째 시트를 가져옴
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
    
                // 시트를 JSON으로 변환
                const excelList: ExcelRow[] = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
                const accountList:AccountRow[] = [];
                setIsOpenModal(false);
                const branch_id = await getBranchId();
                for(const excelRow of excelList){
                    accountList.push({
                        branch_id:branch_id,
                        name:excelRow.성명,
                        id:excelRow.아이디,
                        pw:"toss" + generateRandomNumber(),
                        parent_name:excelRow.부모성함,
                        parent_tel:excelRow.부모연락처,
                        join_date:excelDateToString(excelRow.입원연월일),
                        school:excelRow.학교학년,
                        level:"1",
                        register_date:new Date(),
                        fee:0,
                        shuttle:false,
                        tel:"",
                        unpaied:0
                    })
                }
                let error_list:string[] = [];
                setIsLoading(true)
                for(let i = 0; i < accountList.length; i++){
                    setLoading(Math.ceil(i / accountList.length * 100) || 0);
                    const account = accountList[i];
                    const uid = await createAccount(`${account.id}@toss.kr`, account.pw).then(res => {
                        if(res){
                            return res.uid;
                        }
                        return null;
                    }).catch(err => {
                        console.log(err);
                    })
                    if(uid){
                        const result = await writeFirestore("User/Auth/Student", uid, account).then(res => {
                            if(res){
                                return true;
                            }
                            return false;
                        })
                        const Log = await writeFirestore("User/Auth/Log", uid, account).then(res => {
                            if(res){
                                return true;
                            }
                            return false;
                        })
                        if(!result || !Log){
                            error_list.push(account.name);
                        }
                    }
                }
                if(error_list.length){
                    setModal({
                        title:"ERROR",
                        content:"계정생성중 오류가 발생하였습니다]\n\n오류 계정\n" + error_list.join('\n'),
                        onClick:onModalCloseClickHandler
                    })
                    setIsOpenModal(true);
                }
                setIsLoading(false);
            };
            reader.readAsBinaryString(file);
        }
    };
    const onBatchUploadClickHandler = () => {
        if(fileRef && fileRef.current){
            fileRef.current.click();
        }
    }

    const onFileChangeHandler = (event:ChangeEvent<HTMLInputElement>) => {
        if(event.target.files){
            const file = event.target.files[0];
            setFile(file);
            setModal({
                title:"INFO",
                content:"이전 학생은 그대로 두고 새로운 학생만 업로드 합니다",
                onClick:() => handleReadExcel(file)
            })
            setIsOpenModal(true);
        }
    }

    const onModalCloseClickHandler = () => {
        setIsOpenModal(false);
    }

    return {search, searchedLists, showList, onChange, onRefreshClick, fileRef, onBatchUploadClickHandler, onFileChangeHandler, isOpenModal, modal, onModalCloseClickHandler, isLoading, loading}

}

const Item = styled.div<{ $active?: boolean }>`
    padding: 14px 16px;
    border-bottom: 1px solid ${hw.border};
    color: ${props => props.$active ? hw.brand : hw.text};
    background: ${props => props.$active ? hw.brandSoft : "transparent"};
    font-size: 15px;
    font-weight: ${props => props.$active ? 700 : 500};
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;

    &:hover {
        background: ${props => props.$active ? hw.brandSoft : hw.bg};
        color: ${hw.text};
    }
`

const Empty = styled.div`
    padding: 36px 16px;
    text-align: center;
    color: ${hw.textSubtle};
    font-size: 13px;
`


export default useListView;